/* eslint-disable */
import React, { PropTypes } from 'react';
import { FileDropAreaAnyFileCt } from '../../../commonComponents/FileDropAreaCt';
import { FilesPreview } from '../../../commonComponents/FilesPreviewCt';
import { RequiredStar, PolicySelectField, MultiSelectField } from './news_common_component';

import {
	Modal,
	Button,
	Col,
	Row,
	Well,
	HelpBlock
} from 'react-bootstrap';

import {
	TextField,
	SelectField,
	DatePickerInstance,
	TextAreaField,
	ReadOnlyField,
} from './NewsModalComponentsPs';


export default class NewsModalPs extends React.Component {
	getFlagName(flag) {
		if (flag === 'normal') return <ReadOnlyField fieldValue='一般' />;
		if (flag === 'pin') return <ReadOnlyField fieldValue='置頂' />;
		if (flag === 'star') return <ReadOnlyField fieldValue='重要' />;
	}
	getNewsTypeName(aNewsType_id) {
		let newsTypeArray = this.props.newsTypeArray;
		if (newsTypeArray.length !== 0) {
			for (let i = 0; i < newsTypeArray.length; i++) {//newsTypeArray有可能會增加,故用forLoop找到id的name
				if (aNewsType_id === newsTypeArray[i].id) {
					return <ReadOnlyField fieldValue={newsTypeArray[i].name} />;
				} else {
					continue;
				}
			}
		} else {
			return <ReadOnlyField fieldValue='' />; //如果props還沒傳進來, return空字串
		}
	}
	render() {
		let isAtCreate = this.props.route_type === 'add' ? true : false //是否在news/create
		let {
			closeModal,
			// aNewsId,
			enableEdit,
			// aNewsTitle,
			aNewsTitle_tw,
			aNewsTitle_en,
			aNewsTitle_cn,
			aNewsTitle_ja,
			aNewsFlag,
			aNewsType_id,
			aNewsStart_time,
			aNewsEnd_time,
			// aNewsMessage,
			aNewsMessage_tw,
			aNewsMessage_en,
			aNewsMessage_cn,
			aNewsMessage_ja,
			onClickDelete,
			filesToUpload,
			onDrop,
			aNewsImages,
			aNewsPDFs,
			aNewsVideos,
			fileUploading,
			fileDelete,
			showErrorMsg,
			all_policy,
			userOptions,
			userSelectedValues,
			groupOptions,
			groupSelectedValues,
			multiSelectChangeHandler,
			onPreviewFileDelete
		} = this.props;

		// let { all_policy, userOptions, userSelectedValues, groupOptions, groupSelectedValues } = this.state;

		let showHelpBlock
		if (all_policy === '0' && showErrorMsg && !userSelectedValues.length && !groupSelectedValues.length) {
			showHelpBlock = true;
		}

		return (
			<div>
				<Modal show={true} onHide={closeModal} bsSize='large'
					className='div-newsCt' keyboard={false} backdrop='static'>
					<Modal.Header>
						<Modal.Title>{isAtCreate ? '新增 最新消息' : aNewsTitle_tw}</Modal.Title>
						<span className='span-newsModalBtn'>
							<Button onClick={this.props.closeModal}>關閉</Button>
							{this.editButton()}
						</span>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}><RequiredStar />標題</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Well>
									<Row>
										{
											enableEdit ?
												<Col sm={12}>
													<TextField
														fieldName='aNewsTitle_tw'
														fieldValue={aNewsTitle_tw}
														onChangeHandler={this.props.onChangeHandler}
														isAtCreate={isAtCreate}
														showErrorMsg={showErrorMsg}
														aNewsTitle={aNewsTitle_tw}
														onFocus={this.props.onFocus}
														parent={this} />
												</Col>
												:
												<Col sm={12}>
													<ReadOnlyField
														fieldValue={aNewsTitle_tw} />
												</Col>
										}
									</Row>
								</Well>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}><span style={{ color: 'red' }}>* </span>分類</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Well>
									<Row>
										<Col sm={6}>
											{/* enableEdit ? this.selectField('aNewsFlag') : this.getFlagName(aNewsFlag) */}
											{
												enableEdit ?
													<SelectField
														fieldName='aNewsFlag'
														onChangeHandler={this.props.onChangeHandler}
														selectedFlag={this.props.aNewsFlag}
														selectedNewsTypeId={this.props.aNewsType_id}
														newsTypeArray={this.props.newsTypeArray} />
													: this.getFlagName(aNewsFlag)
											}
										</Col>
										<Col sm={6}>
											{/* enableEdit? this.selectField('aNewsType_id') : this.getNewsTypeName(aNewsType_id) */}
											{
												enableEdit ?
													<SelectField
														fieldName='aNewsType_id'
														onChangeHandler={this.props.onChangeHandler}
														selectedFlag={this.props.aNewsFlag}
														selectedNewsTypeId={this.props.aNewsType_id}
														newsTypeArray={this.props.newsTypeArray} />
													: this.getNewsTypeName(aNewsType_id)
											}
										</Col>
									</Row>
								</Well>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}><span style={{ color: 'red' }}>* </span>時間</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Well>
									<Row>
										<Col sm={6}>
											{/* enableEdit ? this.datePicker('aNewsStart_time') : <ReadOnlyField fieldValue={'開始: ' + aNewsStart_time}/> */}
											{
												enableEdit ?
													<DatePickerInstance
														type='aNewsStart_time'
														enableEdit={enableEdit}
														aNewsStart_time={aNewsStart_time}
														aNewsEnd_time={aNewsEnd_time}
														onChangeDate={this.props.onChangeDate} />
													: <ReadOnlyField fieldValue={'開始: ' + aNewsStart_time} />
											}
										</Col>
										<Col sm={6}>
											{/* enableEdit ? this.datePicker('aNewsEnd_time') : <ReadOnlyField fieldValue={'結束: ' + aNewsEnd_time}/> */}
											{
												enableEdit ?
													<DatePickerInstance
														type='aNewsEnd_time'
														enableEdit={enableEdit}
														aNewsStart_time={aNewsStart_time}
														aNewsEnd_time={aNewsEnd_time}
														onChangeDate={this.props.onChangeDate} />
													: <ReadOnlyField fieldValue={'結束: ' + aNewsEnd_time} />
											}
										</Col>
									</Row>
								</Well>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}><span style={{ color: 'red' }}>* </span>內容</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Well>
									<Row>
										<Col sm={12}>
											<TextAreaField
												fieldName='aNewsMessage_tw'
												aNewsMessage={aNewsMessage_tw}
												enableEdit={enableEdit}
												isAtCreate={isAtCreate}
												showErrorMsg={showErrorMsg}
												onFocus={this.props.onFocus}
												onChangeHandler={this.props.onChangeHandler} />
										</Col>
									</Row>
								</Well>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}><span style={{ color: 'red' }}>* </span>瀏覽權限</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Well>
									<Row>
										<Col sm={12}>
											<PolicySelectField
												onChangeHandler={this.props.onChangeHandler}
												value={all_policy}
												enableEdit={enableEdit}
												helpText={showHelpBlock ? '(請選擇成員或部門)' : ''}
											/>
										</Col>
										{
											all_policy === '0' ?
												<div>
													<Col sm={6} style={{ marginTop: '10px' }}>
														<MultiSelectField
															label='成員'
															multiSelectOptions={userOptions}
															multiSelectedValues={userSelectedValues}
															onChange={(value) => multiSelectChangeHandler('user', value)}
															enableEdit={enableEdit}
														/>
													</Col>
													<Col sm={6} style={{ marginTop: '10px' }}>
														<MultiSelectField
															label='部門'
															multiSelectOptions={groupOptions}
															multiSelectedValues={groupSelectedValues}
															onChange={(value) => multiSelectChangeHandler('group', value)}
															enableEdit={enableEdit}
														/>
													</Col>
												</div>
												: null
										}
									</Row>
								</Well>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<div style={{ fontWeight: 'bold', marginBottom: 5 }}>附件
									{
										fileUploading
											? <span className='glyphicon glyphicon-upload glyphicon-upload-animate'></span>
											: ''
									}
								</div>
							</Col>
						</Row>
						{
							// aNewsId === '' ? '' : 
							<Row>
								<Col sm={12}>
									<Well>
										{
											enableEdit ?
												<Row>
													<Col sm={12}>
														<FileDropAreaAnyFileCt
															uploadedFiles={filesToUpload}
															onDrop={onDrop}
															onPreviewFileDelete={onPreviewFileDelete}
														/>
													</Col>
												</Row> : ''
										}
										<Row>
											<Col sm={12}>
												<FilesPreview
													images={aNewsImages}
													pdfs={aNewsPDFs}
													videos={aNewsVideos}
													enableEdit={enableEdit}
													fileDelete={fileDelete}
												/>
											</Col>
										</Row>
									</Well>
								</Col>
							</Row>
						}
					</Modal.Body>
					<Modal.Footer>
						{isAtCreate ? null : <Button style={{ float: 'left' }} onClick={onClickDelete}>刪除</Button>}{/* 新增的時的Modal, 左下角不會出現'刪除'Btn */}
						{this.editButton()}
						<Button onClick={this.props.closeModal}>關閉</Button>
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
	editButton() {
		//let enableSend = this.props.enableSend;
		/*
			檢視模式: 右上角按鈕為'編輯'
			編輯模式: 右上角按鈕為'儲存'
		*/
		return this.props.enableEdit ?
			<Button onClick={this.props.sendEdit}>儲存</Button>
			:
			<Button onClick={this.props.onClickEdit}>編輯</Button>
	}
	// textField(fieldName,fieldValue){
	//     let isAtCreate = this.props.pathname.includes('news/create');
	//     let showErrorMsg = this.props.showErrorMsg;
	//     let aNewsTitle = this.props.aNewsTitle;
	//     let getHelpBlock = ()=>{
	//         if(isAtCreate){
	//             if(showErrorMsg){
	//                 return aNewsTitle === '' ? <HelpBlock>標題請勿空白</HelpBlock> : null;
	//             } else {
	//                 return null;
	//             }
	//         } else {
	//             //return aNewsTitle === '' ? <HelpBlock>標題請勿空白</HelpBlock> : null;
	//         }
	//     }
	//     return(
	//         <FormGroup>
	//             <FormControl
	//                 type='text'
	//                 value={fieldValue}
	//                 onChange={ event => this.props.onChangeHandler(fieldName, event) }>
	//             </FormControl>
	//             <FormControl.Feedback />
	//             { getHelpBlock() }
	//         </FormGroup>
	//     );
	// }
	// selectField(fieldName){
	//     let selectedFlag = this.props.aNewsFlag;
	//     let selectedNewsTypeId = this.props.aNewsType_id;
	//     let newsTypeArray = this.props.newsTypeArray;
	//     const flagSelector = flag.map( (item,index) => {
	//         return <option key={index} value={item.value} >{item.name}</option>
	//     })
	//     const newsTypeSelector = newsTypeArray.map( (item,index) => {
	//         return <option key={index} value={item.id} >{item.name}</option>
	//     })
	//     let getValue = (fieldName)=> {
	//         switch (fieldName) {
	//             case 'aNewsFlag':
	//                 return selectedFlag;
	//             case 'aNewsType_id': 
	//                 return selectedNewsTypeId;
	//             default:
	//                 return '';
	//         }
	//     }
	//     let getSelector = (fieldName)=>{
	//         switch (fieldName) {
	//             case 'aNewsFlag':
	//                 return flagSelector;
	//             case 'aNewsType_id': 
	//                 return newsTypeSelector;
	//             default:
	//                 break;
	//         }
	//     }     
	//     return(
	//         <FormGroup>
	//             <FormControl      
	//                 componentClass='select'
	//                 value={ getValue(fieldName) }
	//                 onChange={ event=> this.props.onChangeHandler(fieldName, event)}>
	//                 { getSelector(fieldName) }
	//             </FormControl>
	//             <FormControl.Feedback />
	//         </FormGroup>
	//     );
	// }
	// datePicker(type){
	//     let { aNewsStart_time, aNewsEnd_time } = this.props;
	//     let enableEdit = this.props.enableEdit;
	//     //moment(new Date(whatever)) 以避免不合格式的時間字串轉成時間物件後, 跳出deprecated的警告
	//     return(
	//         <FormGroup>
	//             <ControlLabel>{type==='aNewsStart_time'? '開始' : '結束'}</ControlLabel>
	//             <FormControl componentClass='div' readOnly={!enableEdit}>
	//                 <DatePicker
	//                     className='news-date-picker'
	//                     dateFormat='YYYY/MM/DD'
	//                     selected={ type==='aNewsStart_time' ? moment(new Date(aNewsStart_time)) : moment(new Date(aNewsEnd_time))}
	//                     onChange={ date => this.props.onChangeDate(type,date) }
	//                 />
	//             </FormControl>
	//         </FormGroup>
	//     );
	// }
	// textAreaField(aNewsMessage){
	//     let isAtCreate = this.props.pathname.includes('news/create');
	//     let showErrorMsg = this.props.showErrorMsg;
	//     let enableEdit = this.props.enableEdit;
	//     let getHelpBlock = ()=>{
	//         if(isAtCreate){
	//             if(showErrorMsg){
	//                 return aNewsMessage === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null;
	//             } else {
	//                 return null;
	//             }
	//         } else {
	//             //return aNewsMessage === '' ? <HelpBlock>內容請勿空白</HelpBlock> : null;
	//         }
	//     }
	//     return(
	//         <FormGroup>
	//             <FormControl
	//                 readOnly={!enableEdit}
	//                 componentClass='textarea'
	//                 value={aNewsMessage}
	//                 onChange={ event => this.props.onChangeHandler('aNewsMessage', event) }>
	//             </FormControl>
	//             <FormControl.Feedback />
	//             { getHelpBlock() }
	//         </FormGroup>
	//     );
	// }
}

NewsModalPs.PropTypes = {
	enableEdit: PropTypes.bool.isRequired,
	aNewsTitle: PropTypes.string,
	aNewsFlag: PropTypes.string,
	aNewsType_id: PropTypes.string,
	//aNewsStart_time: 
	//aNewsEnd_time: 
	//aNewsMessage: 
}


// WEBPACK FOOTER //
// ./src/salesky/routes/news/NewsModalPs.jsx